// utils
import _ from 'lodash';
import { isBefore, getHours, getMinutes, addDays, addMinutes } from 'date-fns';

function _dateTimeSchedule({ startDateTime, period, frequency, timeStart, timeEnd }) {
  // period in days and frequency in minutes

  if (!frequency) {
    /*  throw Errors.PRECONDITION_FAILED([
      {
        key: `initialize_pad__start_frequency_is_not_valid`,
        data: { frequency }
      }
    ]); */
  }

  const isDateValid = !_.isNil(startDateTime) && _.isDate(new Date(startDateTime));

  if (!isDateValid) {
    /*  throw Errors.PRECONDITION_FAILED([
      {
        key: `initialize_pad__start_date_time_send_is_not_valid`,
        data: { startDateTime }
      }
    ]); */
  }

  const plusPeriod = period;
  const lastDayOfMedicament = addDays(startDateTime, plusPeriod);

  if (isBefore(lastDayOfMedicament, startDateTime)) return [];

  let dateTimes = [new Date(startDateTime)];
  let lastDateTime = new Date(startDateTime);

  while (isBefore(lastDateTime, lastDayOfMedicament)) {
    //
    const plusDateTime = addMinutes(lastDateTime, frequency);
    lastDateTime = plusDateTime;

    if (isBefore(lastDateTime, lastDayOfMedicament)) dateTimes.push(plusDateTime);
  }

  if (timeStart && timeEnd) {
    const validateDateTime = dateTime => !_.isNil(dateTime) && _.isDate(new Date(dateTime));

    const isStartDateTimeValid = validateDateTime(timeStart);
    const isEndDateTimeValid = validateDateTime(timeEnd);

    if (!isStartDateTimeValid || !isEndDateTimeValid) {
      /* throw Errors.PRECONDITION_FAILED([
        {
          key: `initialize_pad__time_start_or_time_end_of_prescription_content_is_not_valid`,
          data: { timeStart, timeEnd }
        }
      ]); */
    }

    // Remove dateTimes out of range timeStart and timeEnd
    dateTimes = [...dateTimes].filter(dateTime => {
      const hourStart = getHours(timeStart);
      const minuteStart = getMinutes(timeStart);

      const hourEnd = getHours(timeEnd);
      const minuteEnd = getMinutes(timeEnd);

      return (
        isEqualTime(dateTime, hourStart, minuteStart) ||
        isEqualTime(dateTime, hourEnd, minuteEnd) ||
        (isAfterTime(dateTime, hourStart, minuteStart) &&
          isBeforeTime(dateTime, hourEnd, minuteEnd))
      );
    });
  }

  return dateTimes;
}

export default _dateTimeSchedule;

function isAfterTime(dateTimeToCompare, hour, minute) {
  const hourToCompare = getHours(dateTimeToCompare);
  const minuteToCompare = getMinutes(dateTimeToCompare);

  if (hourToCompare > hour) {
    return true;
  }
  if (hourToCompare < hour) {
    return false;
  }
  if (hourToCompare === hour) {
    if (minuteToCompare > minute) {
      return true;
    }
    if (minuteToCompare <= minute) {
      return false;
    }
  }
}
function isBeforeTime(dateTimeToCompare, hour, minute) {
  const hourToCompare = getHours(dateTimeToCompare);
  const minuteToCompare = getMinutes(dateTimeToCompare);

  if (hourToCompare < hour) {
    return true;
  }
  if (hourToCompare > hour) {
    return false;
  }
  if (hourToCompare === hour) {
    if (minuteToCompare < minute) {
      return true;
    }
    if (minuteToCompare >= minute) {
      return false;
    }
  }
}
function isEqualTime(dateTimeToCompare, hour, minute) {
  const hourToCompare = getHours(dateTimeToCompare);
  const minuteToCompare = getMinutes(dateTimeToCompare);

  if (hourToCompare === hour) {
    if (minuteToCompare === minute) {
      return true;
    }
    if (minuteToCompare !== minute) {
      return false;
    }
  }

  return false;
}
